"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
}); // #region -------------- Error component -------------------------------------------------------------------

var PeekdataError =
/** @class */
function (_super) {
  __extends(PeekdataError, _super);

  function PeekdataError(message, code, response) {
    var _this = _super.call(this, message) || this;

    _this.toString = function () {
      if (!_this.code && !_this.message) {
        return 'Oops, something went wrong. Have another go.';
      }

      if (!_this.code) {
        return _this.message;
      }

      if (!_this.message) {
        return "Error code: " + _this.code;
      }

      return "Error code: " + _this.code + ". " + _this.message;
    };

    _this.code = code;
    _this.response = response;
    return _this;
  }

  return PeekdataError;
}(Error);

exports.PeekdataError = PeekdataError; // #endregion